/* 
 *  Copyright (c) McAfee Corporation.  All Rights Reserved.
 *
 * Priority configurations
 */
/*--!!!!!ATTENTION!!!!!-----DO NOT DELETE code inside Webpack Macros,it will be used in Analytics SDK for Web */

// #IFDEF WebPack
  
import { globalEngine, ModuleManager } from "./Init"
import { logNormal , logInformation , logWarning , logError, logDebug, logConsole , logRawTrack , logTransports , logAutomationError} from "./bootstrap_web_ext";

// #ENDIF WebPack
function CreatePriorityConfig()
{
	var priority_config = 
	{
		"maxThreshold": 100,
		"minThreshold": 0,
		// append additional thresholds here
		"thresholds":
		{
			"profileThrottle": 10,	// profile-level throttling
			"eventThrottle": 10		// event-level throttling
		},
		"getThreshold": function(thresholdName)
		{
			try
			{
				if (thresholdName in this.thresholds)
				{
					return this.thresholds[thresholdName];
				}
				else
				{
					return 0;
				}
			}
			catch (e)
			{
				logError("getThreshold: failed " + e.message);
				return 0;
			}
		}
	};
	return priority_config;
}

// register with the factory function with ModuleManager
ModuleManager.registerFactory("priority_config", CreatePriorityConfig);

//export  {CreatePriorityConfig};
//globalEngine.FactoryMap["priority_config"] =  CreatePriorityConfig;
